import { client } from '../client';
import { Address, UserProfile } from './types/UserProfile';

export type CreateCareAdvisorPatientPayload = {
  email?: string;
  address?: Address;
  phone_number?: string;
  type: string;
  organization_ids?: string[];
  division_ids?: string[];
  practice_ids?: string[];
  send_invitation?: boolean;
  full_name?: string;
  frontend_website?: string;
  is_quick_add?: boolean;
};

export const createCareAdvisorPatient = async (payload: CreateCareAdvisorPatientPayload): Promise<UserProfile> => {
  const { data } = await client.post<UserProfile>('/care_advisor/users', payload);
  return data;
};
